import React, { useState } from 'react';
import SecondaryButton from '../../components/SecondaryButton';
import { Box, Typography, Stack } from '@mui/material';
import MainLayout from '../../components/MainLayout';
import TourAvailabilityOverlay from '../../components/TourAvailabilityOverlay';
import UpcomingToursCard from '../../components/home/UpcomingToursCard';
import emptytour from '../../assets/emptytour.svg';
import { useAuth } from '../../hooks/useAuth';
import { trackFeatureUsage } from '../../services/FeatureTrackingService';

interface Tour {
  id: string;
  start_time_local: string; // e.g. '2:30pm'
  date: string;       // e.g. 'March 1'
  address: string;
  prospect_name: string;
  phone_number: string;
  move_in_date_requested: string;
  lease_length_requested: string;
  moving_reason: string;
  passed_screening: boolean;
  listing_id: string;
  prospect_id: string;
  status: string; 
  prospect?: {
    name: string;
    email: string;
    phone_number?: string;
    age_range?: string;
    new_renter?: boolean;
    has_year_long_rental?: boolean;
    current_living_situation?: string;
    living_situation_explained?: string;
    student?: boolean;
    undergraduate?: boolean;
    currently_employed?: boolean;
    employer?: string;
    occupation?: string;
    rent_payment_without_job?: string;
    explain_rent_payment?: string;
    income_verifiable?: boolean;
    has_current_job_for_year?: boolean;
    has_one_year_employment_history_last_3_years?: boolean;
    will_do_background_and_credit_check?: boolean;
    num_cats?: number;
    num_dogs?: number;
    lease_length_requested?: string;
    move_in_date_requested?: string;
    moving_reason?: string;
    number_of_applicants?: string;
    tour_preference?: string;
    short_intro?: string;
  } | null;
}

interface ToursPageProps {
  date_grouped_tours: {
    [date: string]: Tour[];
  };
  customer_timezone: string;
}

function formatPhoneNumber(phone: string) {
    // Remove all non-digit characters
    const cleaned = ('' + phone).replace(/\D/g, '');
    // Match and format (201) 401 - 4031
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]} - ${match[3]}`;
    }
    return phone; // fallback to original if not 10 digits
  }

const Tours: React.FC<ToursPageProps> = ({ date_grouped_tours }) => {
  const { user } = useAuth();
  const [availabilityOpen, setAvailabilityOpen] = useState(false);


  return (
    <MainLayout
        headerButton={
            <SecondaryButton onClick={() => {
                if (user?.id) {
                  trackFeatureUsage(user.id, 'Edit Availability');
              }
              setAvailabilityOpen(true)}}>
                Edit Availability
            </SecondaryButton>
        }
    >

        {/* Tours List */}
        { Object.keys(date_grouped_tours).length === 0 ? (
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh"
            textAlign="center">
            <Typography fontWeight="bold" mb={2}>
              <u> Add More Times,</u> Rent Faster
            </Typography>
            <Typography mb={4} color="text.secondary">
              Any new tours will appear here.
            </Typography>
            <img src={emptytour} alt="No tours scheduled" style={{ maxWidth: '300px', height: 'auto' }} />
          </Box>

        ) : (

         <>        
            <Stack spacing={2} alignItems="center">
            {Object.entries(date_grouped_tours).map(([date, tours]) => (
                <Box key={date} mt={4} width="100%">
                  <Typography variant="h6" fontWeight={600}>
                    {new Date(date).toLocaleDateString('en-US', {
                      weekday: 'long',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </Typography>
                  <Stack spacing={2} alignItems="center">
                    {tours.map((tour) => (
                      <UpcomingToursCard key={tour.id} tour={tour} />
                    ))}
                  </Stack>
                </Box>
              ))}           
          </Stack>
        </>
        )}
        <TourAvailabilityOverlay
          open={availabilityOpen}
          onClose={() => setAvailabilityOpen(false)}
        />
    </MainLayout>
  );
};

export default Tours;